import { Food } from '@models/food.model';

export class IncreaseFoodQuantity {
  static readonly type = '[Reservation] Increase Food Quantity';
  constructor(public food: Food | null) {}
}
